/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimestampType } from '../../models/timestamp-type';

export interface GetServiceProviderBillingCsvGroupedBySite$Params {
  from: TimestampType;
  to: TimestampType;
  zip?: boolean;
}

export function getServiceProviderBillingCsvGroupedBySite(http: HttpClient, rootUrl: string, params: GetServiceProviderBillingCsvGroupedBySite$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getServiceProviderBillingCsvGroupedBySite.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('zip', params.zip, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

getServiceProviderBillingCsvGroupedBySite.PATH = '/service-provider/billing/csv-grouped-by-site/timeframe';
